import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { EnvironmentConfig } from '../config';
@Injectable({
  providedIn: 'root'
})
export class CMSService  {
  /**
   * @constructor
   * Creates an instance of the CMSService
   *
   * @param {HttpClient} http Injected instance of HttpClient
 */

  constructor(
    protected http: HttpClient,
    private config: EnvironmentConfig
  ) {
  }
  private baseUrl = 'https://cms.clooper.com/api/'
 /**
  * Sends a get request to the https://cms.clooper.com/api/ endpoint
  * @remarks
  * to get CSR data from the endpoint
  * 
  * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
  */

  getCSRData() {
    const url = `${this.baseUrl}csr-page?populate=*`
    
    return this.http.get<any>(url, {headers: {Authorization: 'Bearer ' + this.config.cmsToken}})
  }

  /**
  * Sends a get request to the https://cms.clooper.com/api/csr-charities?populate=* endpoint
  * @remarks
  * to get  CSR charity  data from the endpoint
  * 
  * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
  */

  getCSRCharityData() {
    const url = `${this.baseUrl}csr-charities?populate=*`
    
    return this.http.get<any>(url, {headers: {Authorization: 'Bearer ' + this.config.cmsToken}})

  }
  /**
  * Sends a get request to the https://cms.clooper.com/api/csr-charities?populate=* endpoint
  * @remarks
  * to get  CSR charity slider images data from the endpoint
  * 
  * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
  */

  getCSRCharitySliderImage() {
    const url = `${this.baseUrl}csr-charities?populate[0]=logo&populate[1]=activities.galleryImages`
    
    return this.http.get<any>(url, {headers: {Authorization: 'Bearer ' + this.config.cmsToken}})

  }
  /**
  * Sends a get request to the https://cms.clooper.com/api/csr-charities?populate=* endpoint
  * @remarks
  * to get  CSR charity slider images data from the endpoint
  * 
  * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
  */

  getCSRCharityActivityDetails() {
    const url = `${this.baseUrl}csr-charities?populate[0]=logo&populate[1]=activities.galleryImages&populate[2]=activities.coverImage`
    
    return this.http.get<any>(url, {headers: {Authorization: 'Bearer ' + this.config.cmsToken}})

  }

  /**
  * Sends a get request to the https://cms.clooper.com/api/csr-sustainable-goals?populate=* endpoint
  * @remarks
  * to get CSR sustainable goal  data from the endpoint
  * 
  * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
  */

  getCSRSustainableGoal() {
    const url = `${this.baseUrl}csr-sustainable-goals?populate=*`
    
    return this.http.get<any>(url, {headers: {Authorization: 'Bearer ' + this.config.cmsToken}})

  }

  /**
  * Sends a get request to the https://cms.clooper.com/api/csr-awards?populate=* endpoint
  * @remarks
  * to get Awards Clooper was Nomited or won 
  * 
  * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
  */

  getClooperAwards() {
    const url = `${this.baseUrl}csr-awards?populate=*`
    
    return this.http.get<any>(url, {headers: {Authorization: 'Bearer ' + this.config.cmsToken}})

  }

  /**
  * Sends a get request to the https://cms.clooper.com/api/csr-awards?populate=* endpoint
  * @remarks
  * to get Clooper fundraising data 
  * 
  * @returns {Observable} Returns an observable of any, with a server-side representations of the matching resources
  */

  getClooperFundraisers() {
    const url = `${this.baseUrl}csr-fundraisers?populate=*`
    
    return this.http.get<any>(url, {headers: {Authorization: 'Bearer ' + this.config.cmsToken}})

  }



  

  


}
